__turbopack_context__.v({
  "activeIndicator": "IssueCardCarousel-module__F0A0LG__activeIndicator",
  "activeSlide": "IssueCardCarousel-module__F0A0LG__activeSlide",
  "arrowButton": "IssueCardCarousel-module__F0A0LG__arrowButton",
  "carouselCard": "IssueCardCarousel-module__F0A0LG__carouselCard",
  "image": "IssueCardCarousel-module__F0A0LG__image",
  "imageContainer": "IssueCardCarousel-module__F0A0LG__imageContainer",
  "imageSlide": "IssueCardCarousel-module__F0A0LG__imageSlide",
  "indicator": "IssueCardCarousel-module__F0A0LG__indicator",
  "indicatorContainer": "IssueCardCarousel-module__F0A0LG__indicatorContainer",
  "nextButton": "IssueCardCarousel-module__F0A0LG__nextButton",
  "prevButton": "IssueCardCarousel-module__F0A0LG__prevButton",
  "slideInFromLeft": "IssueCardCarousel-module__F0A0LG__slideInFromLeft",
  "slideInFromRight": "IssueCardCarousel-module__F0A0LG__slideInFromRight",
  "slidingInNext": "IssueCardCarousel-module__F0A0LG__slidingInNext",
  "slidingInPrev": "IssueCardCarousel-module__F0A0LG__slidingInPrev",
});
